// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export const TvUtcTimeZone = 'Etc/UTC';
export const TvFullSession = '24x7';